import React, { Fragment } from 'react';
import { GoDotFill } from 'react-icons/go';
import { useGuideContext } from '../../../../Contexts/GuidingContext';

// interface IProps {
//   integrationList: any[];
//   handleClick?: (integrationPartyUuid: string, type: string) => void;
//   handleModal?: () => void;
//   handleDisconnect?: (detail: any) => void;
// }

interface IProps {
  integrationList: any[];
  handleModal: (uuid: string, name: string) => void;
  handleCRMConnect: (uuid: string, name: string) => void;
  handleDisconnect?: (detail: any) => void;
}

const IntegrationDataCard = (props: IProps) => {
  const { integrationList, handleModal, handleCRMConnect, handleDisconnect } = props;
  const { currentStep, handleResetStep, setDisabled } = useGuideContext();
  // const handelToConnect = (info: any, index: number) => {
  //   if (handleClick) {
  //     handleClick(info?.uuid, info.name);
  //   }
  //   if (index === 0 && info?.type === 'DATA_SOURCE') {
  //     handleResetStep();
  //     sessionStorage.setItem('guidance', 'completed');
  //     setDisabled(false);
  //   }
  // };
  const handelToConnect = (info: any, index: number) => {
    if (info?.type === 'DATA_SOURCE') {
      handleModal(info?.uuid, info.name);
      if (index === 0) {
        handleResetStep();
        sessionStorage.setItem('guidance', 'completed');
        setDisabled(false);
      }
    } else {
      handleCRMConnect(info?.uuid, info.name);
    }
  };

  const handelToDisconnect = (info: any) => {
    if (handleDisconnect) {
      handleDisconnect(info);
    }
  };
  return (
    <Fragment>
      {integrationList?.length === 0 ? (
        <div className="flex text-gray-300 text-[14px] font-normal p-2 select-none">
          No data found
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-4 w-full sm:ml-[4px] p-2">
          {integrationList.map((info: any, index: number) => (
            <React.Fragment key={info.uuid}>
              {index === 0 && info?.type === 'DATA_SOURCE' && currentStep === 3 && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-10"></div>
              )}
              <div
                key={info.uuid}
                className={`${index === 0 && info?.type === 'DATA_SOURCE' && currentStep === 3 ? ' z-50' : ''} border-[#343434] border-2 rounded-md p-4 flex flex-col justify-between leading-normal gap-3`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex items-center">
                    <img src={info.icon} className="lg:w-10 lg:h-10 w-8 h-8" alt="logo" />
                    <label className="pr-2 pl-2 pt-1  md:text-[14px] text-[12px] font-semibold">
                      {info.name}
                    </label>
                  </div>
                  <div className="flex-shrink-0">
                    <GoDotFill
                      className={'lg:w-[24px] lg:sh-[24px]'}
                      color={info.enabled ? '#28A745' : '#FA0000'}
                    />
                  </div>
                </div>
                <p className=" leading-[25.25px] text-white md:text-[14px] text-[12px]">
                  {info.description}
                </p>
                <div>
                  {!info.enabled && (
                    <button
                      className={` relative text-[12px] md:text-sm font-bold md:px-1.5 px-1 md:py-1 py-[2px] rounded ${info.enabled ? 'cursor-not-allowed bg-[#505050] text-[#A9A9A9]' : 'cursor-pointer bg-white text-[#006BEA]'}`}
                      onClick={() => handelToConnect(info, index)}
                      disabled={info.enabled}
                    >
                      Connect
                      {index === 0 && info?.type === 'DATA_SOURCE' && currentStep === 3 ? (
                        // <span className="absolute rounded-lg bg-[#006bea] w-3 h-3 top-3 right-0"></span>
                        <div className="absolute top-3 right-0">
                          {/* Animated outer glow rings */}
                          <div className="absolute animate-ping w-5 h-5 rounded-full bg-gradient-to-r from-blue-400 to-[#006bea] opacity-20"></div>
                          {/* Main circle with gradient */}
                          <div className="relative w-3 h-3 rounded-full  bg-[#006bea]  "></div>
                        </div>
                      ) : (
                        ''
                      )}
                      {index === 0 && info?.type === 'DATA_SOURCE' && currentStep === 3 && (
                        <>
                          <div className="relative z-20">
                            <div className="absolute w-[11rem] top-[1rem]">
                              <div role="alert" className="rounded-lg text-start bg-[#006BEA] p-3">
                                <h2 className="block font-normal text-sm text-[#FFFFFF]">
                                  {' '}
                                  Click on the Connect button where you will redirect to the shopify
                                  and create account to fetch the products
                                </h2>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </button>
                  )}
                  {info.enabled && (
                    <button
                      className={` relative text-[12px] md:text-sm font-bold md:px-1.5 px-1 md:py-1 py-[2px] rounded cursor-pointer bg-white text-[#006BEA]`}
                      onClick={() => handelToDisconnect(info)}
                    >
                      Disconnect
                    </button>
                  )}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </Fragment>
  );
};
export default IntegrationDataCard;
